import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../../../store';

import { Dispatch } from 'redux';
import { Ii18n } from '../../../../store/utils/contracts/i18n.interface';
import { SvsViews } from '../../../../store/details/svs/model';
import { TabDetails } from '../../../../store/details/svs/types';
import { changeViewBasic, fetchSvs } from '../../../../store/details/svs/actions';
import { connect } from 'react-redux';
import { getI18n } from '../../../../store/utils/i18n/strings.manager';
import styles from './svs-side-nav.module.css';

interface PropsFromState {
  readonly currentView: SvsViews;
  readonly id: number;
  readonly itemsTabs: { [key: string]: TabDetails };
  readonly instructionId: number;
}

interface PropsFromDispatch {
  changeView: typeof changeViewBasic;
  readonly fetchSvs: typeof fetchSvs;
}

type AllProps = PropsFromDispatch & PropsFromState & ConnectedReduxProps;

interface ViewItem {
  view: SvsViews;
  isSelected: boolean;
  item: React.JSX.Element;
}

class SvsSideNav extends React.Component<AllProps> {
  private localization: Ii18n;

  constructor(props: AllProps) {
    super(props);

    this.localization = getI18n();
  }

  private isTabForViewSaved = (item: SvsViews) => {
    if (!this.props.itemsTabs[this.props.id]) { return false; }
    return this.props.itemsTabs[this.props.id][item].isSaved;
  }

  private get views(): ViewItem[] {
    return Object.values(SvsViews).filter(value => !isNaN(Number(value)))
      .map<ViewItem>(value => {
        const castedValue = value as SvsViews;
        const isSelected = this.props.currentView === value;

        return {
          isSelected: isSelected,
          view: castedValue,
          item: (
            <div
              onClick={() => {
                this.props.changeView({ view: value as SvsViews, instructionId: this.props.instructionId });
              }}
              className={isSelected ? styles.viewItemTextSelected : styles.viewItem}
              key={value}>
              <div className={isSelected ? styles.viewItemSelected : this.isTabForViewSaved(castedValue) ? styles.viewItemSaved : ''}></div>
              {this.localization.get(`details.svs.${SvsViews[castedValue].toString()}.header`)}
            </div>
          )
        };
      });
  }

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.scrollableContent}>
          {this.views.map(x => x.item)}

        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ details: { detailsSvs }, caseState: { selectedCase } }: ApplicationState): PropsFromState => ({
  currentView: detailsSvs.currentView,
  itemsTabs: detailsSvs.svsItemsTabs,
  id: detailsSvs.id,
  instructionId: selectedCase.instructionId,
});

const mapDispatchToProps = (dispatch: Dispatch): PropsFromDispatch => ({
  changeView: (data: { view: SvsViews, instructionId: number }) => dispatch(changeViewBasic(data)),
  fetchSvs: (id: number) => dispatch(fetchSvs(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(SvsSideNav);
